import { render, staticRenderFns } from "./CartList.vue?vue&type=template&id=2f66bc00&scoped=true&"
import script from "./CartList.vue?vue&type=script&lang=js&"
export * from "./CartList.vue?vue&type=script&lang=js&"
import style0 from "./CartList.vue?vue&type=style&index=0&id=2f66bc00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f66bc00",
  null
  
)

export default component.exports